import './ProjectShowcase.css'
import ShowcaseDesc from './DescriptionShowcase';

function ShowcaseImage({children, Title = 'Unnamed Project', Date = 'Today', ImgURL = "", ImgAlt = "Missing Alt Text", ButtonURL="", ButtonText="Play", ImageOnLeft = false}) {
    var img = (
        <div className='ShowcaseImage'>
            <img src={(ImgURL.length > 0) ? ImgURL : ("/CookieMissingTexture.png")} alt={ImgAlt}/>
        </div>
    );
    var content = (
        <div className='ShowcaseContent'>
            <ShowcaseDesc
                Title={Title}
                Date={Date}
                ButtonURL={ButtonURL}
                ButtonText={ButtonText}
            >
                {children}
            </ShowcaseDesc>
        </div>
    );

    if (ImageOnLeft) {
            content = (
                <>
                    {img}
                    {content}
                </>
            );
        }
        else {
            content = (
                <>
                    {content}
                    {img}
                </>
            );
        }
    
    return(
        <div className="Showcase">
            {content}
        </div>
    );
}

export default ShowcaseImage;